import { tickTimer } from "../store/slice/spinner";
import store from "../store/index";

let timerInterval = null;

export const startGlobalTimer = () => {
  if (timerInterval) return;

  timerInterval = setInterval(() => {
    store.dispatch(tickTimer());
  }, 1000);
};

export const formatTimeRemainingInSecond = (second) => {
  if (!second || second <= 0) return "00:00:00";

  const totalSeconds = Math.floor(second);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map(val => val.toString().padStart(2, '0'))
    .join(':');
};
